import { render, staticRenderFns } from "./LayoutWithNavigation.vue?vue&type=template&id=3c2d4e8a&scoped=true&"
import script from "./LayoutWithNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutWithNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWithNavigation.vue?vue&type=style&index=0&id=3c2d4e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d4e8a",
  null
  
)

export default component.exports